import { Container } from "../../components/Container";
import { Body, Content } from "../../components/Body";
import { Title } from "../../components/Title";
import content from "./Text.json";
import { useTitleChange } from "hooks/useTitleChange";
export const TermsConditions = () => {
  useTitleChange("Términos y Condiciones");
  return (
    <Container>
      <Title>Términos y Condiciones</Title>
      <Body content={content as Content[]} />
    </Container>
  );
};
